import { render } from "./ReportCreateComponent.vue?vue&type=template&id=04adf6ce&scoped=true"
import script from "./ReportCreateComponent.vue?vue&type=script&lang=js"
export * from "./ReportCreateComponent.vue?vue&type=script&lang=js"

import "./ReportCreateComponent.vue?vue&type=style&index=0&id=04adf6ce&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04adf6ce"]])

export default __exports__